import { SwxTheme } from 'swx-atomic-component-lib'

const { x2, x6, getX } = SwxTheme.sizing
const { fontSize } = SwxTheme.component.general

const styles = {
  dropdown: `
      height: auto; 
      z-index: 1001;
      position: absolute;
      top: ${getX(10)};
      right: 0;
    `,
  overflowWrapper: `
      width: ${getX(30)};
      height: ${getX(27)};
      box-shadow: 5px 5px 5px 0 rgba(0, 0, 0, 0.1);
      border: solid 2px ${SwxTheme.palette.primary};
      background-color: ${SwxTheme.palette.white};
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: -${x2};
      top: -33px;
    `,
  menuItem: `
      &:hover {
        background-color: ${SwxTheme.palette.primary};
        .item-label, svg {
          cursor: pointer;
          color: ${SwxTheme.palette.white} !important; /*existing style use important!*/
        }
        .item-label {
          margin-top: 0;
        }
      }
      font-size: ${fontSize}
    `,
  triggerPoint: `
      position: absolute;
      top: -${getX(10)};
      right: 0;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: ${x6};
      justify-content: center;
    `
}

export default styles
